export const DEFAULT_OPEN_DIALOG_DELAY_MS = 10_000

export const FIELD_EVALUATION_REPORT_DIALOG_SHOWN_KEY = 'field-evaluation-report-dialog-shown-key'

export const FIELD_EVALUATION_REPORT_DIALOG_SHOWN_VALUE = 'true'
